import styled from 'styled-components';
import { BLOCK_OPACITY_TIME, BLOCK_TRANSFORM_TIME } from './constants';
export const FadeBottomToTopContainer = styled.div `
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transform: ${({ isVisible }) => (isVisible ? `none` : `translateY(20vh)`)};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  transition: opacity ${BLOCK_OPACITY_TIME}s ease-out,
    transform ${BLOCK_TRANSFORM_TIME}s ease-out;
`;
//# sourceMappingURL=styles.js.map